/**
 * This file contains all the global constants used in the application.
 */

/**
 * The last hour to show in the calendar views. If the number is greater than 24, the calendar will show the next day.
 */
export const CALENDAR_LAST_HOUR = 24 + 8
